import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FC } from 'react';

type Icon3dIndicatorProps = {
    className?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Icon3dIndicator: FC<Icon3dIndicatorProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'icon3d-indicator'}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
        >
            <polygon points="182.3,49.3 125,18 67.7,49.3 125,79.5" />
            <polygon points="120.1,85.7 63.2,54.8 63.2,119 120.1,149.9" />
            <polygon points="129.9,149.9 186.8,119 186.8,54.8 129.9,85.7" />
            <path d="M213.3 84.8c-2.1-1.3-4.9-.6-6.2 1.6-1.3 2.1-.6 4.9 1.6 6.2 20.8 12.3 32.3 28.3 32.3 45 0 13.7-7.6 26.9-22.1 38.1-14.5 11.3-35.3 19.8-58.5 24.1-2.4.4-4.1 2.8-3.6 5.2.4 2.2 2.3 3.7 4.4 3.7.3 0 .5 0 .8-.1 52.6-9.6 88-38.1 88-71.1 0-20-13-38.7-36.7-52.7z" />
            <path d="M112.2 183.8c-1.6-1.9-4.4-2.2-6.3-.6-1.9 1.6-2.2 4.4-.6 6.3l10.8 13.2c-28-1.2-54-8.1-73.9-19.6-21.3-12.4-33-28.5-33-45.5 0-16.4 11-32.1 31-44.3 2.1-1.3 2.8-4.1 1.5-6.2-1.3-2.1-4.1-2.8-6.2-1.5C12.6 99.5 0 117.9 0 137.6c0 20.3 13.3 39.2 37.5 53.3 21.5 12.4 49.4 19.8 79.3 20.9l-15 12.3c-1.9 1.6-2.2 4.4-.6 6.3.9 1.1 2.2 1.6 3.5 1.6 1 0 2-.3 2.9-1l22.5-18.4c1.9-1.6 2.2-4.4.6-6.3l-18.5-22.5z" />
        </svg>
    );
};

export default Icon3dIndicator;
